//
// ███████╗████████╗ █████╗ ████████╗███████╗
// ██╔════╝╚══██╔══╝██╔══██╗╚══██╔══╝██╔════╝
// ███████╗   ██║   ███████║   ██║   █████╗
// ╚════██║   ██║   ██╔══██║   ██║   ██╔══╝
// ███████║   ██║   ██║  ██║   ██║   ███████╗
// ╚══════╝   ╚═╝   ╚═╝  ╚═╝   ╚═╝   ╚══════╝
//
const state = {
  updates: {},
  updatesSelected: [],
  allSelected: false
}

//
//  ██████╗ ███████╗████████╗████████╗███████╗██████╗ ███████╗
// ██╔════╝ ██╔════╝╚══██╔══╝╚══██╔══╝██╔════╝██╔══██╗██╔════╝
// ██║  ███╗█████╗     ██║      ██║   █████╗  ██████╔╝███████╗
// ██║   ██║██╔══╝     ██║      ██║   ██╔══╝  ██╔══██╗╚════██║
// ╚██████╔╝███████╗   ██║      ██║   ███████╗██║  ██║███████║
//  ╚═════╝ ╚══════╝   ╚═╝      ╚═╝   ╚══════╝╚═╝  ╚═╝╚══════╝
//
const getters = {

}

//
// ███╗   ███╗██╗   ██╗████████╗ █████╗ ████████╗██╗ ██████╗ ███╗   ██╗███████╗
// ████╗ ████║██║   ██║╚══██╔══╝██╔══██╗╚══██╔══╝██║██╔═══██╗████╗  ██║██╔════╝
// ██╔████╔██║██║   ██║   ██║   ███████║   ██║   ██║██║   ██║██╔██╗ ██║███████╗
// ██║╚██╔╝██║██║   ██║   ██║   ██╔══██║   ██║   ██║██║   ██║██║╚██╗██║╚════██║
// ██║ ╚═╝ ██║╚██████╔╝   ██║   ██║  ██║   ██║   ██║╚██████╔╝██║ ╚████║███████║
// ╚═╝     ╚═╝ ╚═════╝    ╚═╝   ╚═╝  ╚═╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝╚══════╝
//
const mutations = {
  /**
     * Add an update to the selected updates array
     *
     * @param state
     * @param payload
     */
  addSelectedUpdate (state, payload) {
    state.updatesSelected.push(payload)
    if (state.updatesSelected.length === state.updates.data.length) {
      state.allSelected = true
    }
  },

  /**
     * Remove an update from the selected updates array
     *
     * @param state
     * @param payload
     */
  removeSelectedUpdate (state, payload) {
    state.updatesSelected.splice(state.updatesSelected.indexOf(payload), 1)
    state.allSelected = false
  },

  /**
     * Set the allSelected property (all sites in the sites view are selected)
     *
     * @param state
     * @param payload
     */
  setSelectAll (state, payload) {
    state.updatesSelected = []
    state.updates.data.forEach((item) => {
      const update = state.updates.data.find((u) => {
        return u.id === item.id
      })

      if (update.data.ignore_update === 0) {
        state.updatesSelected.push(item.id)
      }
    })
    state.allSelected = true
  },

  /**
   * Set updates array, get data from the backend and convert it for better usage
   *
   * @param state
   * @param payload
   */
  setUpdates (state, payload) {
    // state.sites = payload;
    const data = payload.data
    const meta = payload.meta

    state.updates.meta = meta
    state.updates.data = []
    state.updates.sites = []

    data.forEach((element) => {
      let update = this.transformDataItem(element)

      state.updates.data.push(update)
    })
  },

  setProcessStateRunning (state, payload) {
    state.updates.data.forEach((e) => {
      if (e.id === payload) {
        e.data.process_state = 1
      }
    })
  },

  /**
     * reset the selected updates array
     *
     * @param state
     */
  unsetSelectAll (state) {
    state.updatesSelected = []
    state.allSelected = false
  },

  updateLocalStoreExtensionProcessState (state, payload) {
    let euid = payload.context.euid
    let processState = 0

    // Get extension process state
    payload.data.updates.forEach((e) => {
      if (e.id === euid) {
        processState = e.process_state
      }
    })

    state.updates.data.forEach((e) => {
      if (e.id === euid) {
        if (e.data.process_state === 1 && processState === 0) {
          e.data.process_state = 2
        } else {
          e.data.process_state = processState
        }
      }
    })
  },

  updateLocalStoreExtensionIgnoreUpdateState (state, payload) {
    if (typeof state.updates.data !== 'undefined') {
      let euid = payload.context.euid
      let ignoreState = 0

      // Get the ignore_state for the extension
      payload.data.extensions.forEach((e) => {
        if (euid === e.id) {
          ignoreState = e.ignore_update
        }
      })

      state.updates.data.forEach((e) => {
        if (e.id === euid) {
          e.data.ignore_update = ignoreState
        }
      })
    }
  },

  /**
     *
     * @param state
     * @param payload
     */
  updateLocalStoreExtensionsAfterProcess (state, payload) {
    if (typeof state.updates.data !== 'undefined') {
      state.updates.data.forEach((e) => {
        if (e.id === payload.id) {
          e.data.process_state = payload.process_state_extension
          if (payload.process_state_extension === 0) {
            // Show success
            e.data.process_state = 2
          }
        }
      })
    }
  }
}

//
//  █████╗  ██████╗████████╗██╗ ██████╗ ███╗   ██╗███████╗
// ██╔══██╗██╔════╝╚══██╔══╝██║██╔═══██╗████╗  ██║██╔════╝
// ███████║██║        ██║   ██║██║   ██║██╔██╗ ██║███████╗
// ██╔══██║██║        ██║   ██║██║   ██║██║╚██╗██║╚════██║
// ██║  ██║╚██████╗   ██║   ██║╚██████╔╝██║ ╚████║███████║
// ╚═╝  ╚═╝ ╚═════╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝╚══════╝
//
const actions = {

  /**
     *
     * @param commit
     * @param state
     * @param payload
     */
  afterProcess ({ commit, state }, payload) {
    /*
        id: payload.extension_id,
        type: 'update',
        subtype: 'extension',
        extension_id: payload.id,
        site_id: payload.site_id,
        result: 'failed'
        process_state_extension: payload.process_state_extension,
        process_state_site: payload.process_state_site,
        */
    if (payload.type === 'update') {
      // We have updated an extension
      if (payload.subtype === 'extension') {
        commit('updateLocalStoreExtensionsAfterProcess', payload)
      }

      if (payload.subtype === 'core') {

      }
    }
  },

  /**
     * Get items for the view
     *
     * @param commit
     * @param state
     * @param payload
     *
     * @returns {Promise<any>}
     */
  getUpdates ({ commit, state }, payload) {
    let limit = payload.limit
    let sort = payload.sort
    let dir = payload.dir
    let page = payload.page
    let search = payload.search
    let site = payload.site

    return new Promise((resolve, reject) => {
      this._vm.axios.get(
        '/api/accountupdates?page=' + page + '&limit=' + limit + '&sort=' + sort + '&dir=' + dir +
                            '&search=' + search + '&site=' + site
      )
        .then(response => {
          commit('setUpdates', response.data)
          resolve(response.data)
        }
        )
    })
  },

  /**
   * Update an extension
   *
   * @param commit
   * @param dispatch
   * @param state
   * @param payload   extension id
   */
  updateExtension ({ commit, dispatch, state }, payload) {
    commit('setProcessStateRunning', payload)

    dispatch('extensions/updateExtension', payload, { root: true }).then(
      response => {
        dispatch('updateLocalStore', response)
      })
  },

  /**
     * Process all updates that are viewable at the moment
     *
     * @param commit
     * @param dispatch
     * @param state
     */
  updateViewablePage ({ commit, dispatch, state }) {
    state.updates.data.forEach((item) => {
      if (item.data.ignore_update === 0) {
        commit('setProcessStateRunning', item.id)

        dispatch('extensions/updateExtension', item.id, { root: true }).then(
          response => {
            dispatch('updateLocalStore', response)
          })
      }
    })

    commit('unsetSelectAll')
  },

  /**
     * Process all updates that are selected
     *
     * @param commit
     * @param dispatch
     * @param state
     */
  updateSelected ({ commit, dispatch, state }) {
    state.updatesSelected.forEach((item) => {
      state.updates.data.forEach((e) => {
        if (e.id === item) {
          commit('setProcessStateRunning', e.id)
        }
      })

      dispatch('extensions/updateExtension', item, { root: true })
    })

    commit('unsetSelectAll')
  },

  /**
     * Update the local store based on action and source
     *
     * @param dispatch
     * @param state
     * @param payload
     */
  updateLocalStore ({ commit, state }, payload) {
    let context = payload.context

    if (context.source === 'local' && context.type === 'extension') {
      commit('updateLocalStoreExtensionProcessState', payload)
    }

    if (context.source === 'remote' && context.type === 'extension') {
      commit('updateLocalStoreExtensionProcessState', payload)
    }
  }

}

//
// ███████╗██╗  ██╗██████╗  ██████╗ ██████╗ ████████╗
// ██╔════╝╚██╗██╔╝██╔══██╗██╔═══██╗██╔══██╗╚══██╔══╝
// █████╗   ╚███╔╝ ██████╔╝██║   ██║██████╔╝   ██║
// ██╔══╝   ██╔██╗ ██╔═══╝ ██║   ██║██╔══██╗   ██║
// ███████╗██╔╝ ██╗██║     ╚██████╔╝██║  ██║   ██║
// ╚══════╝╚═╝  ╚═╝╚═╝      ╚═════╝ ╚═╝  ╚═╝   ╚═╝
//
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
